<template>
  <div class="content">
    <!-- Не найдено -->
    <template v-if="store.abiturient?.status === 'not_found'">
      <div class="join join--col">
        <h4>Мы ничего не нашли!</h4>
        <p>
          Если вы уверены, что уже подавали заявление, обратитесь в Приёмную комиссию
          по телефону <a href="tel:+78007759025">8-800-775-9025</a>.
        </p>
      </div>
      <div class="form__actions">
        <button class="btn btn--primary" @click="onRetry">Повторить поиск</button>
      </div>
    </template>

    <!-- Форма поиска -->
    <template v-else>
      <div class="card card--info">
        <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
        <p>Введите данные документа, удостоверяющего личность, по которому было подано заявление</p>
      </div>

      <form class="form" @submit.prevent="onSubmit">
        <fieldset class="form form--fieldset">
          <div class="form__group">
            <t-text v-model="searchForm.surname" label="Фамилия" name="surname" required/>
            <t-text v-model="searchForm.name" label="Имя" name="name" required/>
            <t-text v-model="searchForm.patronymic" label="Отчество"/>
          </div>

          <div class="form__group">
            <t-datepicker v-model="searchForm.birthdate" label="Дата рождения" name="birthdate" required/>
            <div class="form__spacer"></div>
            <div class="form__spacer"></div>
          </div>

          <div class="form__group">
            <t-text v-model="searchForm.identity_series" label="Серия паспорта" name="identity_series"/>
            <t-text v-model="searchForm.identity_number" label="Номер паспорта" name="identity_number" required/>
            <t-datepicker v-model="searchForm.identity_date" label="Дата выдачи" name="identity_date" required/>
          </div>
        </fieldset>

        <div class="form__actions">
          <button class="btn btn--primary" :disabled="isButtonDisabled">
            Поиск
          </button>
        </div>
      </form>

      <!-- Идёт поиск -->
      <template v-if="isProgressShown">
        <div class="card card--info">
          <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
          <p>{{ store.abiturient.status_message || 'Идёт поиск заявлений...' }}</p>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, computed } from 'vue'
import { createConsumer } from '@rails/actioncable'
import { TText, TDatepicker } from '@shared/ui'
import { useAbiturientStore } from '@pages/abiturient'
import { useFormErrors } from '@shared/lib'

const store = useAbiturientStore()
const { setErrors } = useFormErrors()

const searchForm = ref({
  surname: store.form?.surname || '',
  name: store.form?.name || '',
  patronymic: store.form?.patronymic || '',
  birthdate: store.form?.birthdate || '',
  identity_series: '',
  identity_number: '',
  identity_date: '',
})

// ActionCable
let cable = null
let subscription = null

const isButtonDisabled = computed(() => ['processing', 'importing', 'imported'].includes(store.abiturient?.status))
const isProgressShown = computed(() => ['processing', 'importing', 'imported', 'failed'].includes(store.abiturient?.status))

const subscribe = (abiturientId) => {
  cable = createConsumer()
  subscription = cable.subscriptions.create(
    { channel: 'RequestedAbiturientChannel', abiturient_id: abiturientId },
    {
      received(data) {
        store.abiturient.status = data.status
        store.abiturient.status_message = data.message
        if (data.status === 'imported') {
          store.fetchForm()
        }
      }
    }
  )
}

const unsubscribe = () => {
  subscription?.unsubscribe()
  cable?.disconnect()
  subscription = null
  cable = null
}

watch(() => store.abiturient?.id, (id, prevId) => {
  unsubscribe()
  if (id) subscribe(id)

  if (id && !prevId) {
    searchForm.value = {
      surname: store.abiturient.surname || '',
      name: store.abiturient.name || '',
      patronymic: store.abiturient.patronymic || '',
      birthdate: store.abiturient.birthdate || '',
      identity_series: store.abiturient.identity_series || '',
      identity_number: store.abiturient.identity_number || '',
      identity_date: store.abiturient.identity_date || '',
    }
  }
})

onMounted(async () => {
  await store.fetchAbiturient()
})

onUnmounted(unsubscribe)

const onSubmit = async () => {
  try{
    await store.searchAbiturient(searchForm.value)
    await store.fetchAbiturient()
  } catch(error) {
    if(error.response?.data?.errors) {
      setErrors(error.response?.data?.errors.abiturient)
    }
  }
}

const onRetry = () => {
  store.abiturient = null
}
</script>
